module.exports = __webpack_public_path__ + "static/img/14.002dd7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour6/14.jpg
// module id = 8dJ/
// module chunks = 0